import React, { useContext, useEffect } from 'react';
import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
} from '@mui/material';
import {
  Truck as TruckIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
  Sliders as SlidersIcon,
  User as UserIcon,
  Package as PackageIcon,
  File as FileIcon,
  Store as StorefrontIcon,
  Settings,
} from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import NavItem from './NavItem';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import accessRight from '../../utils/functions/accessRight';
import * as action from '../../redux/actions';
import { Store } from '@mui/icons-material';
import { CreditCardIcon } from 'lucide-react';

const items = [
  {
    href: '/gold',
    icon: Store,
    title: 'ซื้อ- ขาย',
    name: 'GOLD',
    sub: [
      {
        href: '/gold',
        title: 'ซื้อ-ขาย',
        level: 0,
      },
      {
        href: '/gold/summary',
        title: 'สรุปรายการซื้อ-ขาย',
        level: 0,
      },
      // {
      //   href: '/gold/history',
      //   title: 'สรุปรายการเงินสด',
      //   level: 0,
      // },
      // {
      //   href: '/gold/reportgold',
      //   title: 'รายงานการซื้อ-ขาย',
      //   level: 0,
      // },
      {
        href: '/gold/history-payment',
        title: 'บัญชีรายวัน',
        level: 0,
      },
    ],
  },
  {
    href: '/material',
    icon: PackageIcon,
    title: 'คลังทอง',
    name: 'MATERIAL',
    sub: [
      {
        href: '/material/material-stock',
        title: 'สรุปสินค้าคงเหลือ',
        level: 0,
      },
      {
        href: '/material/prepare-gold',
        title: 'คลังเริ่มต้น',
        level: 0,
        name: 'MATERIAL',
      },
      {
        href: '/material/material-data',
        title: 'จัดการข้อมูลสินค้า',
        level: 0,
        name: 'MATERIAL',
      },
      // {
      //   href: '/material/place',
      //   title: 'การตั้งค่าคลังสินค้า',
      //   level: 1,
      //   name: 'MATERIAL',
      //   sub: [
      //     {
      //       href: '/material/place',
      //       title: 'จัดการคลังสินค้า',
      //       level: 1,
      //     },
      //     {
      //       href: '/material/material-type',
      //       title: 'จัดการประเภทสินค้า',
      //       level: 1,
      //     },
      //     {
      //       href: '/material/material-transaction-type',
      //       title: 'จัดการประเภทการดำเนินการ',
      //       level: 0,
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   href: '/customer',
  //   icon: UsersIcon,
  //   title: 'คู่ค้า',
  //   name: 'CUSTOMER',
  //   sub: [
  //     {
  //       href: '/customer',
  //       title: 'รายการลูกค้า',
  //       level: 0,
  //     },
  //     {
  //       href: '/customer/customer-types',
  //       title: 'ประเภทลูกค้า',
  //       level: 1,
  //     },
  //   ],
  // },

  {
    href: '/accounting',
    icon: CreditCardIcon,
    title: 'การบัญชี',
    name: 'ACCOUNTING',
    sub: [
      {
        href: '/accounting',
        title: 'รายการซื้อ-ขาย',
        level: 0,
      },
      {
        href: '/accounting/report',
        title: 'รายงานซื้อขายส่งบัญชี',
        level: 1,
      },
    ],
  },
  {
    href: '/information',
    icon: SlidersIcon,
    title: 'การตั้งค่า',
    name: 'INFORMATION',
    sub: [
      {
        href: '/information',
        title: 'จัดการข้อมูลระบบ',
        level: 0,
      },
      {
        href: '/information/customers',
        title: 'จัดการข้อมูลคู่ค้า',
        level: 0,
      },
      // {
      //   href: '/information/place',
      //   title: 'จัดการคลังทอง',
      //   level: 1,
      // },
      // {
      //   href: '/information/material-type',
      //   title: 'จัดการประเภทสินค้า',
      //   level: 1,
      // },
      {
        href: '/information/employee',
        icon: UserPlusIcon,
        title: 'ตั้งค่าผู้ใช้งาน',
        name: 'INFORMATION',
        sub: [
          {
            href: '/information/employee',
            title: 'จัดการพนักงาน',
            level: 0,
          },
          {
            href: '/information/department',
            title: 'จัดการแผนก',
            level: 1,
          },
          {
            href: '/information/user',
            title: 'จัดการผู้ใช้',
            level: 0,
          },
        ],
      },
    ],
  },
  {
    href: '/user/material-type',
    icon: Settings,
    title: 'ผู้ดูแลระบบ',
    name: 'USER',
    sub: [
      {
        href: '/user/material-type',
        title: 'จัดการประเภทสินค้า',
        level: 1,
      },
      {
        href: '/user/history',
        title: 'ประวัติการจัดการทอง',
        level: 1,
      },
    ],
  },
];

const DashboardSidebar = ({ me, onMobileClose, openMobile }) => {
  const {
    firstname = '',
    lastname = '',
    department: { name: departmentName = '' } = {},
  } = JSON.parse(getStorage('remember'));

  const dispatch = useDispatch();
  const information = useSelector((state) => state.information);

  const user = {
    jobTitle: departmentName,
    name: `${firstname} ${lastname}`,
  };
  const handleRemoveNotify = async () => {
    await dispatch(
      // eslint-disable-next-line no-underscore-dangle
      action.employeePut(me?.userData?._id, { line_token: null }),
    );
    await dispatch(action.meGet());
  };

  const renderNofifyButton = () => {
    const lineNotifyAccessLink = `https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=${information?.client_id}&redirect_uri=${information?.redirect_uri}&scope=notify&state=${me?.userData?._id}`;

    if (me?.userData?.line_token && me?.userData?.line_token !== '') {
      return (
        <div className="flex  gap-2">
          <a href={lineNotifyAccessLink}>
            <Button variant="contained" color="warning">
              เปลี่ยนบัญชี
            </Button>
          </a>{' '}
          <Button
            variant="contained"
            color="error"
            onClick={() => handleRemoveNotify()}
          >
            ยกเลิก
          </Button>
        </div>
      );
    }
    return (
      <a href={lineNotifyAccessLink}>
        <Button variant="contained" color="success">
          รับการแจ้งเตือนผ่าน LINE
        </Button>
      </a>
    );
  };

  const { handleSignout } = useContext(PassportAuth);
  const history = useHistory();

  const onSignOut = async () => {
    await handleSignout();
    history.push('/login');
  };

  const location = useLocation();
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box className="p-6">
        <div className="p-2 rounded-xl flex flex-wrap justify-center  bg-gray-50">
          <div className="lg:w-1/3 flex justify-center ">
            <div className="bg-gray-300 rounded-full p-1">
              <UserIcon size={40} color={'grey'} />
            </div>
          </div>
          <div className="w-full lg:w-2/3 text-center">
            <Typography color="textPrimary" variant="body2">
              {user.name}
            </Typography>
            <Typography color="palevioletred" variant="body2">
              {user.jobTitle}
            </Typography>
          </div>
        </div>
        {/* <div className="pl-2 py-2">{renderNofifyButton()}</div> */}
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => {
            if (accessRight(me, item.name)) {
              return (
                <div key={item.title}>
                  <NavItem
                    href={item.href}
                    title={item.title}
                    icon={item.icon}
                    sub={item.sub}
                    me={me}
                    moduleName={item.name}
                  />
                </div>
              );
            }
            return <></>;
          })}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Divider />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2,
        }}
      >
        <Button
          size="xs"
          startIcon={<i className="fas fa-fingerprint"></i>}
          variant="outlined"
          onClick={() => {
            onSignOut();
          }}
        >
          ออกจากระบบ
        </Button>
      </Box>
    </Box>
  );

  return (
    <div>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256,
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)',
              zIndex: 0,
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </div>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  me: PropTypes.object,
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default DashboardSidebar;
